import React from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { LoginSchema } from "../../utils/zodSchema/user";
import { useNavigate } from "react-router-dom";
import { postLogin } from "api/user";
import useUserStore from "@store/useUserStore";
import { trackLogin } from "utils/analytics";
import { TokenManager, syncNativeAccessToken, syncNativeRefreshCookie } from "utils/api";

const LoginForm = () => {
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({ resolver: zodResolver(LoginSchema) });

    const setUserInfo = useUserStore((state) => state.setUserInfo);

    const submitLogin = async (formData) => {
        const validatedData = LoginSchema.parse(formData);
        try {
            const response = await postLogin(validatedData.email, validatedData.password);
            if (response?.code === "0000") {
                const accessToken = response.token.access;

                TokenManager.saveAccessToken(accessToken);
                syncNativeAccessToken(accessToken);
                await syncNativeRefreshCookie();

                trackLogin("email");

                setUserInfo(response.user);
                navigate("/", { replace: true });
            } else {
                console.error("로그인 실패:", response);
                alert("로그인에 실패했습니다. 아이디와 비밀번호를 확인해주세요.");
            }
        } catch (error) {
            console.error("로그인 오류:", error);
            alert("로그인에 실패했습니다. 아이디와 비밀번호를 확인해주세요.");
        }
    };

    return (
        <form className="input-wrap" onSubmit={handleSubmit(submitLogin)}>
            <div className="input-form">
                <input
                    placeholder="이메일"
                    className="input"
                    {...register("email")}
                />
                {errors.email && (
                    <p className="validation-error">{errors.email.message}</p>
                )}
            </div>
            <div className="input-form">
                <input
                    type="password"
                    placeholder="비밀번호"
                    className="input"
                    {...register("password")}
                />
                {errors.password && (
                    <p className="validation-error">
                        {errors.password.message}
                    </p>
                )}
            </div>
            <div className="btn-wrap btn-wrap-no-Xpadding">
                <button type="submit" className={`btn btn-large btn-login`}>
                    로그인
                </button>
            </div>
        </form>
    );
};

export default LoginForm;
